import "./css/iconfont.css";

import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import MintUI from "mint-ui";
import "mint-ui/lib/style.css";
Vue.use(MintUI);
// import { Toast } from 'mint-ui';
// Vue.use(Toast);
//
import App from "./App.vue";
import router from "./router/main";
import store from "./store/index";
//导入自定义样式
import "./styles.scss";
//导入axios
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
//导入打印功能
import Print from "vue-printjs";
Vue.use(Print);
//
import "zhb-ui/dist/zhb-ui.css"; // 引入zhbui样式库
//导入element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

//加载自定义常用函数模块
import Common from "@/plugins/common.js";
Vue.use(Common);
//加载自定义axios模块
import custAxios from "@/plugins/custAxios.js";
Vue.use(custAxios);
//加载应用API模块
import PstApi from "@/plugins/pstapi.js";
Vue.use(PstApi);
//加载用户API模块
import UserApi from "@/plugins/userapi.js";
Vue.use(UserApi);
//
Vue.prototype._isMobile = function() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};

let startApp = async function() {
  //初始化用户API axios 允许携带cookie true
  await Vue.prototype.CustAxios.CreateCustAxios(
    "/config.json",
    "EduUserAxios",
    true
  );
  await Vue.prototype.CustAxios.CreateCustAxios("/config.json", "WXPstAxios");
  if (Vue.prototype._isMobile() == null) {
    Vue.prototype.PAGESIZE = 10;
    Vue.prototype.ISMOBILE = false;
    Vue.prototype.LABELPOSTION = "right";
  }
  //渲染页面
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");

  //向服务器读取系统参数
  // var res = await Vue.prototype.pstApi.getWebsiteParameters();
  // if (!(res.status && res.status == 200)) {
  //   console.log('网站参数读取失败');
  //   return '';
  // } else {
  //   //系统参数获取成功后设置系统参数
  //   var parameters = res.data;
  //   Vue.prototype.pstApi.setWebsiteParameters(parameters)
  //   //console.log(Vue.prototype.SystemTitle);

  // }
};

startApp();
